export const serviceBaseURL = "/externo-portal-backend/v1";
export const backendBaseURL = "/externo-portal-backend"

export const USER_ANON = "ANONIMO";
export const ANON_HEADER = "x-anon-key";
export const ANON_HEADER_KEY = "QU5PTklNTw==";
